import React from "react";
import {Col, Row} from "react-bootstrap";

import "react-table/react-table.css";
import BizLocationSelector from "../component/BizLocation/BizLocationSelector";
import BizStepSelector from "../component/BizStep/BizStepSelector";
import ProductTypeSelector from "../productType/component/ProductTypeSelector";
import DispositionSelector from "../disposition/DispositionSelector";

class BalanceGridFilter extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      defaultDate: props.defaultDate,
      onChange: props.onChange,
      productTypes: localStorage.getItem('productTypesIds'),
      bizStep: localStorage.getItem('bizStepIds'),
      dispositions: localStorage.getItem('dispositionsIds'),
      bizLocation: localStorage.getItem('bizLocationIds'),
    };
  }

  render() {
    const {onChange} = this.state;

    const handleSetValue = (filterEntity) => {
      return (value) => {
        if (Array.isArray(value)) {
          this.state[filterEntity] = value.map(x => x.id).join(',')
        } else {
          this.state[filterEntity] = value
        }

        onChange && onChange(this.state)
      }
    }

    return (
      <div>
        <Row>
          <Col sm={3}>
            <BizLocationSelector
              multiple
              defaultValue={this.state.bizLocation}
              setValue={
                handleSetValue('bizLocation')
              }
            />
          </Col>
          <Col sm={3}>
            <ProductTypeSelector
              defaultValue={this.state.productTypes}
              multiple
              setValue={
                handleSetValue('productType')
              }
            />
          </Col>
          <Col sm={3}>
            <DispositionSelector
              defaultValue={this.state.dispositions}
              multiple
              setValue={
                handleSetValue('dispositionId')
              }
            />
          </Col>
          <Col sm={3}>
            <BizStepSelector
              multiple
              defaultValue={this.state.bizStep}
              setValue={
                handleSetValue('bizStep')
              }
            />
          </Col>
        </Row>
      </div>
    );
  }
}

export default BalanceGridFilter;



// WEBPACK FOOTER //
// ./src/balance/BalanceGridFilter.js